import React from 'react';
import {Box, styled} from "@mui/material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { bannerData } from '../../constants/data';


const Image=styled("img")(({ theme })=>({

  width: "100%",
  height: "280px",
  [theme.breakpoints.down('md')]:{
    objectFit: 'cover',
    height: '180px'
  }
}))


const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };


const Banner = () => {
  return (
    <Carousel 
        responsive={responsive}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        containerClass="carousel-container"
        swipeable={false}
        draggable={false}
        ssr={true} // means to render carousel on server-side.
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={4000}
        keyBoardControl={true}
        // customTransition="all .5"
        transitionDuration={500}
        slidesToSlide={1}
    >
        {
            bannerData.map((data, index)=>(
                <Image key={index} src={data.url} alt="banner" />
            ))
        }
    </Carousel>
  )
}

export default Banner;